(function() { module.exports = window["Next"]["DatePicker"]; }());